import { stockOperationService } from '../../helpers/services/stockOperation.service'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: { data: [], pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 } },
  details: {},
  opType: 'receive',
  status: { list: true, detail: true, save: true },
}

export const STOCK_OPERATION_MODULE = 'stockOperation'

export const GET_ALL_STOCK_OPERATIONS = 'getAllStockOperations'
export const GET_STOCK_OPERATION = 'getStockOperation'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const DETAIL_SUCCESS = 'detailSuccess'
const SET_OP_TYPE = 'setOpType'

function mapRow(item) {
  return {
    docNo: item.doc_no,
    docDate: filtersHelper.getDateFormat(item.doc_date),
    location: item.location,
    toLocation: item.to_location,
    description: item.description,
    total: item.total,
    items: (item.items || []).map((i) => ({
      itemCode: i.item_code,
      qty: i.qty,
      uom: i.uom,
      unitCost: i.unit_cost,
      description: i.description,
    })),
  }
}

export const actions = {
  [GET_ALL_STOCK_OPERATIONS]({ commit }, { opType, filter }) {
    commit(REQUESTING, 'list')
    commit(SET_OP_TYPE, opType)
    stockOperationService.getAllStockOperations(opType, filter).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_STOCK_OPERATION]({ commit }, { opType, docNo }) {
    commit(REQUESTING, 'detail')
    return stockOperationService.getStockOperation(opType, docNo).then((r) => {
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [DETAIL_SUCCESS](state, data) {
    state.details = data.data ? mapRow(data.data) : {}
  },
  [SET_OP_TYPE](state, t) { state.opType = t },
  [FAILURE](state) { state.status = { list: true, detail: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, detail: true, save: true } },
}
